import { MonthPlanSimpleDto } from "shared/api";

export const getOpenMonth = (monthPlans: Array<MonthPlanSimpleDto> = []) => {
  let open: MonthPlanSimpleDto | undefined = undefined;

  for (const monthPlan of monthPlans) {
    if (monthPlan.weeks.find((it) => !it.closed)) {
      open = monthPlan;
    } else {
      break;
    }
  }

  return open;
};
